import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import { AutoHeader } from '../Common'
import videoForm from './config/video-form'
import { withAuthentication } from '../Session'

class VideoModifyPage extends React.Component {
   constructor(props) {
      super(props)
      this.state = { loading: true }
   }

   async componentDidMount() {
      const { data: item } = await videoForm.actions.read(
         this.props.match.params.id,
      )
      this.setState({
         item,
         loading: false,
      })
   }

   render() {
      if (!this.state.item) {
         return <div />
      }
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent
                  form={videoForm}
                  data={this.state.item}
                  {...this.props}
               />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(VideoModifyPage)
